<script>
    export default {
        props: {},
        methods: {
            set_title(v) {
                this.title = v
            }
        },
        computed: {},
        watch: {},
        components: {
            client_search(h) {
                return import('./client/search/index.vue');
            },
            client_item(h) {
                return import('./client/item/index.vue');
            },
            agreement_pay(h) {
                return import('./agreement/pay/index.vue');
            },
        },
        mounted() {

        },
        destroyed() {
            document.body.removeChild(this.$el);

        }
    }
</script>
<template>
    <div>
        <el-dialog
                :visible.sync="visible"
                :title="title"
                @close="close"
                class="modal">
            <div class="modal__body">
                <component
                        v-bind:is="type"
                        ref="dialog"
                        :param="param"
                        :close="close"
                        :set_title="set_title"
                        :change="change">
                </component>
            </div>
        </el-dialog>
    </div>

</template>
<style lang="scss">

    .modal {
        &__footer {
            padding-top: 16px;
            text-align: right;
        }
        &__block {
            padding: 16px;
            box-shadow: 0 0 4px 0 #999;
            height: 100%;
            margin-bottom: 8px;
        }
        &__body {
            min-height: 300px;
            b {
                font-weight: 700;
            }
            hr{
                margin: 0 0 16px 0;
                background: #ddd;
                border: none;
                height: 1px;
            }
        }
        .el-dialog {
            margin-top: 50px !important;
        }
        .el-dialog__body {
            padding: 8px 16px 16px 16px;
            min-height: 368px;
        }
    }
</style>